export default "__VITE_ASSET__py2RsQ39__"